/**
 * 中央カラム下部: 群間比較・統計詳細・論文用タブ
 */

import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import { useKeisukeDashboardStore } from '../../../../stores/systems/keisuke/dashboardStore';
import KeisukeDashboardResultTabs from './KeisukeDashboardResultTabs';
import styles from './KeisukeDashboardResultsStrip.module.scss';

export default function KeisukeDashboardResultsStrip({
  embedded = false,
}: {
  /** 白カード内に同居するとき二重枠を消す */
  embedded?: boolean;
}) {
  const { t } = useTranslation();
  const { lastErrorMessage, setLastErrorMessage } = useKeisukeDashboardStore(
    useShallow((s) => ({
      lastErrorMessage: s.lastErrorMessage,
      setLastErrorMessage: s.setLastErrorMessage,
    }))
  );

  return (
    <section
      className={`${styles.strip}${embedded ? ` ${styles.stripEmbedded}` : ''}`}
      aria-label={t('keisuke.workspace.results')}
      {...(embedded ? { 'data-keisuke-results-embedded': '' } : {})}
    >
      {lastErrorMessage && (
        <div className={styles.errorAlert} role="alert">
          <span>{lastErrorMessage}</span>
          <button
            type="button"
            className={styles.errorDismiss}
            onClick={() => setLastErrorMessage(null)}
            aria-label={t('keisuke.dashboard.tooltips.closeError')}
          >
            <i className="fas fa-times" aria-hidden />
          </button>
        </div>
      )}
      <KeisukeDashboardResultTabs fillHeight={embedded} />
    </section>
  );
}
